export default {
    "map_landmarksettings_landmarks": "Puntos de Ref",
    "map_landmarksettings_landmarks_groups": "Grupo de Puntos",
    "map_landmarksettings_landmarks_tags": "Etiquetas:",
    "map_landmarksettings_landmarks_note": "Notas",
    "map_landmarksettings_landmarks_none": "Ninguno",
};